import { Connector, Shop, Snapshot } from "@ticketmachine/sdk";
import { Readable } from "svelte/store";
import { createCartConnector, createSnapshotListener } from "./cart";
import { buildTranslations } from "./helpers";
import createResolverConnector from "./resolve";
import createSeatingChartConnector from "./seating_chart";
import { URLS } from "./urls";
import createWizardConnector from "./wizards";


export function createConnectorFromListener(snapshot: Readable<Snapshot>, setSnapshot: () => Promise<void>, urls: URLS) {
    const cart = createCartConnector(snapshot, setSnapshot, urls);
    const [getCachedEvent, resolver] = createResolverConnector(snapshot, setSnapshot, urls);
    const seatingChart = createSeatingChartConnector(snapshot, setSnapshot, getCachedEvent, urls);
    const wizards = createWizardConnector(snapshot, setSnapshot, () => connector, urls);

    const connector = {
        async initialize() {},
        ...cart,
        ...resolver,
        ...seatingChart,
        ...wizards
    } as any as Connector
    return connector;
}


export async function createConnector(name: string, urls: URLS): Promise<Connector> {
    const [snapshot, setSnapshot] = await createSnapshotListener(name, urls);
    return createConnectorFromListener(snapshot, setSnapshot, urls);
}


export async function createShop(name: string, urls: URLS): Promise<Shop> {
    return await Shop.create({
      onError(e: Error) {
          window.reportError(e, {shop: name});
      },
      connector: await createConnector(name, urls),
      translator: buildTranslations()
    });

}
